import { Components } from '@mui/material/styles/components';
import { ControllerFont } from '../../fonts';
import theme from '../../provider/controllerBaseTheme';

export const ListComponent: Components = {
  MuiList: {
    styleOverrides: {
      root: {
        color: theme.palette.text.primary,
        ...ControllerFont.Heading200B,
      },
    },
  },
  MuiListItemIcon: {
    styleOverrides: {
      root: {
        color: theme.palette.text.primary,
        minWidth: theme.spacing(4),
      },
    },
  },
};
